export const STATE_KEY = 'customerListing'

export const SET_CUSTOMER_LISTING = 'SET_CUSTOMER_LISTING'
export const APPEND_CUSTOMER_LISTING = 'APPEND_CUSTOMER_LISTING'
export const SET_CUSTOMER_LISTING_LOADING = 'SET_CUSTOMER_LISTING_LOADING'
export const SET_CUSTOMER_LISTING_LOADING_MORE = 'SET_CUSTOMER_LISTING_LOADING_MORE'
export const SET_CUSTOMER_LISTING_ERROR = 'SET_CUSTOMER_LISTING_ERROR'
export const CLEAR_CUSTOMER_LISTING = 'CLEAR_CUSTOMER_LISTING'
export const CLEAR_CUSTOMER_LISTING_CURSOR = 'CLEAR_CUSTOMER_LISTING_CURSOR'
// Dispatched after a service-item send/resend/acquire round-trip (C3): swaps
// one row in place with the server's re-hydrated copy, keyed by subjectId.
export const REPLACE_CUSTOMER_LISTING_ROW = 'REPLACE_CUSTOMER_LISTING_ROW'

// Mirrors the /customer-listing response envelope: { rows, total, pdfRowCap,
// facetCounts, nextCursor, asOf }. facetCounts/total/pdfRowCap only ride the
// first page of a filter set, so they're cached here across cursor pages of the
// SAME set and only replaced (never merged) when a fresh first-page request
// lands.
const initialState = {
  loading: false,
  loadingMore: false,
  hasLoaded: false,
  error: null,
  rows: [],
  total: null,
  pdfRowCap: null,
  facetCounts: null,
  nextCursor: null,
  asOf: null,
}

export default function customerListingReducers(state = initialState, action) {
  switch (action.type) {
    case SET_CUSTOMER_LISTING_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
      }
    case SET_CUSTOMER_LISTING_LOADING_MORE:
      return {
        ...state,
        loadingMore: true,
        error: null,
      }
    case SET_CUSTOMER_LISTING:
      return {
        ...state,
        loading: false,
        loadingMore: false,
        hasLoaded: true,
        error: null,
        ...action.payload,
      }
    case APPEND_CUSTOMER_LISTING:
      return {
        ...state,
        loading: false,
        loadingMore: false,
        hasLoaded: true,
        error: null,
        rows: [...state.rows, ...action.payload.rows],
        nextCursor: action.payload.nextCursor,
      }
    case SET_CUSTOMER_LISTING_ERROR:
      return {
        ...state,
        loading: false,
        loadingMore: false,
        hasLoaded: true,
        error: action.payload,
      }
    case CLEAR_CUSTOMER_LISTING:
      return { ...initialState }
    // Disarms the infinite-scroll sentinel the instant filters change, so a
    // scroll during the apply debounce can't fire a load-more with the old
    // cursor against the new filter set (a guaranteed cursor-hash 400).
    case CLEAR_CUSTOMER_LISTING_CURSOR:
      return { ...state, nextCursor: null }
    // One row swapped in place after send/resend/acquire — every other row is
    // left untouched (a full re-fetch would blow away load-more'd pages).
    case REPLACE_CUSTOMER_LISTING_ROW:
      return { ...state, rows: state.rows.map(r => (r.subjectId === action.payload.subjectId ? action.payload : r)) }
    default:
      return state
  }
}
